<template>
  <div class="app-container">

    <el-button style="margin-bottom: 20px" type="primary" size="small" @click="goBack">返回</el-button>

    <el-tabs v-model="activeIndex" type="border-card">
      <!-- detail -->
      <el-tab-pane label="详情" name="reviewDetail">
        <review-detail :live-i-d="liveID"></review-detail>
      </el-tab-pane>

      <!-- 观看信息 -->
      <el-tab-pane label="观看信息" name="watchInfo">
        <watch-info :live-i-d="liveID"></watch-info>
      </el-tab-pane>

      <!-- 评论回复 -->
      <el-tab-pane label="评论回复" name="replayList">
        <replay-list :live-i-d="liveID"></replay-list>
      </el-tab-pane>

      <el-tab-pane label="视频收益" name="creditOrderList">
        <credit-order-list :live-i-d="liveID"></credit-order-list>
      </el-tab-pane>
    </el-tabs>
  </div>

</template>

<script>

import WatchInfo from "@/views/mai/liveReview/reviewDetail/watchInfo";
import ReviewDetail from "@/views/mai/liveReview/reviewDetail/reviewDetail";
import ReplayList from "@/views/mai/liveReview/reviewDetail/replayList";
import CreditOrderList from "@/views/mai/liveReview/reviewDetail/CreditOrderList";

export default {
  name: "index",
  components: {CreditOrderList, ReplayList, ReviewDetail, WatchInfo},
  data() {
    return {
      liveID: 0,
      activeIndex:"reviewDetail"
    }
  },
  created() {
    this.liveID = this.$route.query.liveID
  },
  methods: {
    goBack() {
      this.$router.back()
    }
  }
}
</script>

<style scoped>

</style>